import { render, staticRenderFns } from "./CompanyIntroSection.vue?vue&type=template&id=c520f772&scoped=true"
import script from "./CompanyIntroSection.vue?vue&type=script&lang=js"
export * from "./CompanyIntroSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroSection.vue?vue&type=style&index=0&id=c520f772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c520f772",
  null
  
)

export default component.exports